import styled from 'styled-components';

export const VideoPlayerContainer = styled.iframe`
    width:100%;
    height:315px;
`